import React from 'react';
import ReactDOM from 'react-dom/client';

import { QueryClientProvider } from '@tanstack/react-query';

import GlobalLoader from './components/GlobalLoader';
import RoutesComponent from './routes';
import queryClient from './helpers/queryClient';

import './i18n';
import './styles/index.css';
import './helpers/globalAuth';
import './helpers/sentry';

ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <RoutesComponent />
    <GlobalLoader />
  </QueryClientProvider>
);
